import React from 'react';
import { Seo } from '../components/Seo';
import { Appointment } from '../components/Appointment';

export const AppointmentPage: React.FC = () => {
  return (
    <div className="pt-20">
      <Seo
        title="קביעת תור | RIHAM קליניקה אסתטית וטבעית"
        description="קביעת תור לטיפול אסתטי, יעוץ עור או רוקחות צמחים אישית בקליניקה של רהאם מנסור במושב פטיש."
        path="/appointment"
      />
      <Appointment />
    </div>
  );
};
